import { useEffect, useMemo, useState } from "react";

import { ServiceData } from "../../../Services/Service";
import ModalBordereauFormAdmin from "../../../View/ModalBordereauFormAdmin";
import BordereauCard from "../../../View/BordereauCard";
import { grouperParPeriode } from "../../../View/GroupeParPeriode";
import { PlusCircle } from "lucide-react";
import { Listes } from "../../../Types/Listes";
import { validateBordereauForm } from "../../../View/validateBordereauForm";
import { toast } from "react-toastify";
import { handleAddNumBl, handleNumBlChange, handleRemoveNumBl, onDelete } from "../../../Services/DataAction";


const Bordereau = () => {
 
  const [bordereaux, setBordereaux] = useState<Listes[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [search,setSearch]=useState<string>('');
  


  const [form,setForm]=useState({
    destinataire:'',
    nombres:null,
    nombrepack:null,
    bon:'',
    NumBl:[''],
    livreur:'',
    vehicule:'',
    chaffeur:'',
    telephone:'',
    cooperative:'',
    datelivraison:''
  })


  const [isModalOpen,setIsModalOpen]=useState<boolean>(false);
  const [isEditMode,setIsEditMode]=useState<boolean>(false);
  const [isModifier,setIsModifier]=useState<boolean>(false);
  const [selectedUser, setSelectedUser] = useState<Listes | null>(null);
  const [filteredBordereaux, setFilteredBordereaux] = useState<Listes[]>([]);
  const [showVerifiedOnly,setShowVerifiedOnly]=useState<boolean>(false);
  const [showSentOnly,setShowSentOnly]=useState<boolean>(false);
  const isAdminOrMagasinLoin = true;


  const fetchLBordereau = async () => {
    try {
      const response = await ServiceData(
        "/api/admin/listbordereau",
        "GET"
      );
      if(Array.isArray(response)){
        setBordereaux(response);
        setFilteredBordereaux(response); 
      }
    } catch (err: any) {
      setError("Erreur lors du chargement des bordereaux");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLBordereau();
  }, []);

  const validateForm = (): boolean => {
    return validateBordereauForm(form, isEditMode ? "edit" : "create",isAdminOrMagasinLoin, setError);
  };

  const searchData=(e:React.ChangeEvent<HTMLInputElement>)=>{
    const value=e.target.value;
    setSearch(value);

    const filter=bordereaux.filter((item)=>
          `${item.Destinataire} ${item.Expediteur} ${item.Chaffeur} ${item.NumBl.join(" ")} ${item.NumberBordereau}`
          .toLowerCase()
          .includes(value.toLowerCase())
    );
    setFilteredBordereaux(filter);    
  }

  const groupes=useMemo(()=>{
    let result=filteredBordereaux;
    if(showVerifiedOnly){
      result=result.filter(item=>item.isVerified === false)
    }
    if(showSentOnly){
      result=result.filter(item=>item.isSend === false);
    }
    return grouperParPeriode(result);
  },[filteredBordereaux,showVerifiedOnly,showSentOnly])





  if (isLoading) return <div className="text-center m-5 text-muted">Chargement...</div>;


  const openCreatePiece=()=>{
      setIsModalOpen(true);
      setIsEditMode(false);
      setForm({
        destinataire:'',
        nombres:null,
        nombrepack:null,
        bon:'',
        NumBl:[''],
        livreur:'',
        vehicule:'',
        chaffeur:'',
        telephone:'',
        cooperative:'',
        datelivraison: new Date().toISOString().slice(0, 16)
      })
      setError(null);
    }


    const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const commonPayload = {
        destinataire: form.destinataire,
        nombres: form.nombres,
        nombrepack: form.nombrepack,
        bon: form.bon,
        NumBl:form.NumBl,
        livreur: form.livreur,
        vehicule: form.vehicule,
        chaffeur: form.chaffeur,
        telephone: form.telephone,
        cooperative: form.cooperative,
        datelivraison: form.datelivraison 
      };

      if (isEditMode && selectedUser) {
        await ServiceData(`/api/admin/editbordereau/${selectedUser.id}`, 'PUT', commonPayload);
        setBordereaux(prev =>
          prev.map(b => b.id === selectedUser.id ? { ...b, ...commonPayload } : b)
        );
        if (selectedUser.isSend) {
          for (let i = 1; i <= 3; i++) {
            localStorage.removeItem(`alerte-${selectedUser.id}-H${i}`);
          }
        }
        toast.success("✅ Bordereau mis à jour avec succès");


      } else if (isModifier && selectedUser) {
        console.log(commonPayload);
        
        await ServiceData(`/api/admin/modifierbordereau/${selectedUser.id}`, 'PUT', commonPayload);
        setBordereaux(prev =>
          prev.map(b => b.id === selectedUser.id ? { ...b, ...commonPayload } : b)
        );
        // toast.success("✅ Bordereau modifié avec succès");
      } else {
        const createPayload = {
          destinataire: form.destinataire,
          nombres: form.nombres,
          nombrepack: form.nombrepack,
          bon: form.bon,
          datelivraison: form.datelivraison,
          NumBl:form.NumBl
        };

        const newItem = await ServiceData(`/api/admin/createbordereau`, 'POST', createPayload);
        setBordereaux(prev => [...prev, newItem]);
        toast.success("✅ Bordereau créé avec succès");
      }

      fetchLBordereau(); // pour synchroniser avec le backend
      closeModal(); // referme la modale

    } catch (err: any) {
      setError(err.message || "❌ Erreur serveur.");
      toast.error(err.message || "❌ Erreur serveur.");
    }
  };


    

    const closeModal = () => {
      setIsModalOpen(false);
      setSelectedUser(null);
      setIsEditMode(false);
      setIsModifier(false);
      setError(null);
    };
    const handleInputChange = (key: string, value: string) => {
      setForm(prev => ({ ...prev, [key]: value }));
    };

    const onVerifie = async (liste: Listes) => {
      try {
        await ServiceData(`/api/admin/verifier/${liste.id}`, 'PUT');
        toast.success("✔️ Bordereau vérifié avec succès");
        fetchLBordereau();
      } catch (err: any) {
        toast.error("❌ Vous n'avez pas l'autorisation de vérifier ce bordereau");
      }
    };




    const supprimer = (liste: Listes) => {
      onDelete(liste, fetchLBordereau);
    };

    const ChangerNumBl=(index:number,value:string)=>{
      handleNumBlChange(form,setForm,index,value);
    }
    const AddNumBl=()=>{
      handleAddNumBl(form,setForm);
    }
    const RemoveNumBl=(index:number)=>{
      handleRemoveNumBl(form,setForm,index);
    }


  return (
  <div className="col g-2 align-items-center mb-3">
    <div className="col-12 col-md-6 m-auto mb-3">
      <input
        className="form-control"
        type="text"
        placeholder="Rechercher"
        value={search}
        onChange={searchData}
      />
    </div>
    <div className="col-12 col-md-6 d-flex flex-wrap gap-3 m-auto align-items-center">
      <button className="btn btn-outline-dark d-flex align-items-center gap-2" onClick={openCreatePiece}>
        <PlusCircle /> Créer pièces
      </button>

      <div className="form-check form-switch">
        <input
          className="form-check-input"
          type="checkbox"
          id="switch-verified"
          checked={showVerifiedOnly}
          onChange={() => setShowVerifiedOnly(prev => !prev)}
        />
        <label className="form-check-label" htmlFor="switch-verified">
          Non vérifiés
        </label>
      </div>

      <div className="form-check form-switch">
        <input
          className="form-check-input"
          type="checkbox"
          id="switch-sent"
          checked={showSentOnly}
          onChange={() => setShowSentOnly(prev => !prev)}
        />
        <label className="form-check-label" htmlFor="switch-sent">
          Non livrés
        </label>
      </div>
    </div>


    {isModalOpen && <ModalBordereauFormAdmin form={form} error={error} isEditMode={isEditMode} isAdminOrMagasinLoin={isAdminOrMagasinLoin} handleSubmit={handleSubmit} handleInputChange={handleInputChange} closeModal={closeModal} isModifier={isModifier} handleNumBlChange={ChangerNumBl} handleAddNumBl={AddNumBl} handleRemoveNumBl={RemoveNumBl}/> }
    {Object.entries(groupes).map(([periode, elements]) =>
      elements.length > 0 ? (
        <div key={periode} className="mb-5">
          <h4 className="text-primary mb-3">{periode}</h4>
          <div className="row g-4">
            {elements.map((b) => (
              <div className="col-12 col-md-6 col-lg-3" key={b.id}>
                <BordereauCard b={b} setForm={setForm} setIsEditMode={setIsEditMode} setIsModalOpen={setIsModalOpen} setSelectedUser={setSelectedUser} setError={setError} onVerifie={onVerifie} onDelete={supprimer} setIsModifier={setIsModifier} />
              </div>
            ))}
          </div>
        </div>
      ) : null
    )}
  </div>
  );
};

export default Bordereau;
